import React from 'react';
import { motion } from 'framer-motion';
import SEO from './shared/SEO';
import PageLayout from './layout/PageLayout';

const AboutPage = () => {
  const aboutSchema = {
    "@context": "https://schema.org",
    "@type": "AboutPage",
    "mainEntity": {
      "@type": "Organization",
      "name": "COTAD",
      "foundingDate": "2015",
      "description": "An inclusive church providing support and services to disowned and abused youth in our community",
      "nonprofitStatus": "501(c)(3)"
    }
  };

  return (
    <>
      <SEO
        title="About COTAD | Inclusive Church Supporting Youth"
        description="An inclusive church providing support, counseling, and sanctuary to youth aged 11-30 through our Neverland initiative."
        pathname="/about"
      >
        <script type="application/ld+json">
          {JSON.stringify(aboutSchema)}
        </script>
      </SEO>

      <PageLayout
        title="About Us"
        description="Building a community of acceptance and support"
      >
        <section className="about-main-content">
          <div className="about-main-container">
            <motion.div 
              className="max-w-4xl mx-auto"
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.8, delay: 0.2 }}
            >
              <div className="about-main-text">
                <p>
                  COTAD is more than just a place of worship - we're a sanctuary for those who need it most. Through our Neverland Initiative, we provide comprehensive support services for youth aged 11 to 30 who have been disowned or faced abuse from their families.
                </p>
                
                <p>
                  As an inclusive church, we believe that everyone deserves acceptance, support, and the opportunity to thrive. Our dedicated team offers a range of services, from counseling and spiritual guidance to educational programs and community support. We create a safe space where individuals can heal, grow, and build meaningful connections.
                </p>
                
                <p>
                  We are proud to be a registered 501(c)(3) nonprofit organization, allowing us to accept tax-deductible donations that directly support our mission and services. Your support helps us continue providing essential services to those in need.
                </p>
              </div>
            </motion.div>
          </div>
        </section>
      </PageLayout>
    </>
  );
};

export default AboutPage;